<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({ path: '/' })">首页</span>
        <span>></span>
        <span>收藏</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="top-nav">
            <ul>
              <li
                v-for="(item, i) in navList"
                :key="i"
                :class="i == isActive ? 'actives' : ''"
                @click="change(i)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div class="article" v-if="isActive == 0">
            <ul>
              <li v-for="(item, i) in articleList" :key="i" v-if="item.article">
                <div class="img" @click="articleDetail(item.article)">
                  <img
                    :src="item.article.cover_url"
                    alt
                    v-if="item.article.cover_url.indexOf(',') == -1"
                  />
                  <img :src="item.article.cover_url.split(',')[0]" alt v-else />
                </div>
                <div class="cont">
                  <p @click="articleDetail(item.article)">
                    {{ item.article.title }}
                  </p>
                  <div class="num">
                    {{ item.article.display_time | timefilters }} · 阅读时长{{
                      item.article.visit_times
                    }}分钟 · {{ item.article.comment_times }}字
                  </div>
                  <div class="read">
                    <div>{{ item.article.visit_times }} 阅读</div>
                    <div>
                      <span>
                        {{ item.article.like_times }}
                        <img
                          src="@/assets/img/like2.png"
                          alt
                          v-if="item.article.is_like"
                          @click="praiseBtn(item.article.id, i)"
                        />
                        <img
                          src="@/assets/img/like1.png"
                          alt
                          @click="praiseBtn(item.article.id, i)"
                          v-else
                        />
                      </span>
                      <span @click="articleDetail(item.article)">
                        {{ item.article.comment_times }}
                        <img src="@/assets/img/icon_comment.png" alt />
                      </span>
                    </div>
                  </div>
                </div>
              </li>
              <div v-else class="noData">暂无数据</div>
            </ul>
            <p class="loadMore" @click="loadMore" v-if="showMore">
            加载更多
            <p style="text-align:center;margin-top:4px;" v-if="showMore">
                <img src="@/assets/img/more.png" alt />
              </p>
            </p>
          </div>
          <div class="hot" v-else>
            <ul>
              <li v-for="(item, i) in hotList" :key="i" v-if="item.article">
                <div class="img" @click="radioDetail(item)">
                  <img
                    :src="item.article.cover_url"
                    alt
                    v-if="item.article.cover_url.indexOf(',') == -1"
                  />
                  <img :src="item.article.cover_url.split(',')[0]" alt v-else />
                </div>
                <div class="hot-box">
                  <p @click="radioDetail(item)">{{ item.article.title }}</p>
                  <div class="cont">{{ item.article.summary }}</div>
                  <div class="num">
                    <div>
                      <img src="@/assets/img/play1.png" alt />
                      <!-- visit_times -->
                      <span>{{ item.article.visit_times }}</span>
                    </div>
                    <div>
                      <img src="@/assets/img/clock.png" alt />
                      <!-- audio_duration -->
                      <span>{{
                        item.article.audio_duration | timeToString
                      }}</span>
                    </div>
                  </div>
                </div>
              </li>
              <div v-else class="noData">暂无数据</div>
            </ul>
            <p class="loadMore" @click="loadMore" v-if="showMores">
            加载更多
           <p style="text-align:center;margin-top:4px;" v-if="showMores">
                <img src="@/assets/img/more.png" alt />
              </p>
            </p>
          </div>
        </div>
        <div class="content-r">
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDownMenu from "@/components/dropDownMenu";
import { getCollectArcticleList } from "@/api/collect";
import { getArctileLike } from "@/api/public";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    DropDownMenu
  },
  data() {
    return {
      isActive: 0,
      navList: [{ title: "文章" }, { title: "音频" }],
      articleList: [],
      hotList: [],
      params: {
        page: 1,
        per: 5,
        type: "Article"
      },
      showMore: false,
      showMores: false
    };
  },
  methods: {
    change(flag) {
      this.isActive = flag;
      this.params.page = 1;
      if (this.isActive == 0) {
        this.params.type = "Article";
        getCollectArcticleList(this.params).then(res => {
          this.articleList = res.data.data;
          if (res.data.meta.current_page >= res.data.meta.total_pages) {
            this.showMore = false;
          } else {
            this.showMore = true;
          }
        });
      } else {
        this.params.type = "AudioArticle";
        getCollectArcticleList(this.params).then(res => {
          this.hotList = res.data.data;
          if (res.data.meta.current_page >= res.data.meta.total_pages) {
            this.showMores = false;
          } else {
            this.showMores = true;
          }
        });
      }
    },
    // 加载更多
    loadMore() {
      this.params.page++;
      if (this.isActive == 0) {
        this.params.type = "Article";
        getCollectArcticleList(this.params).then(res => {
          for (var i in res.data.data) {
            this.articleList.push(res.data.data[i]);
          }
          if (res.data.meta.current_page >= res.data.meta.total_pages) {
            this.showMore = false;
          } else {
            this.showMore = true;
          }
        });
      } else {
        this.params.type = "AudioArticle";
        getCollectArcticleList(this.params).then(res => {
          for (var i in res.data.data) {
            this.hotList.push(res.data.data[i]);
          }
          if (res.data.meta.current_page >= res.data.meta.total_pages) {
            this.showMores = false;
          } else {
            this.showMores = true;
          }
        });
      }
      this.resetSetItem("getFixeds", true);
    },
    getList(params) {
      getCollectArcticleList(params).then(res => {
        this.articleList = res.data.data;
        // this.hotList = res.data.data;
        if (res.data.meta.current_page >= res.data.meta.total_pages) {
          this.showMore = false;
        } else {
          this.showMore = true;
        }
      });
    },
    // 文章点赞
    praiseBtn(id, i) {
      getArctileLike(id).then(res => {
        this.articleList[i].article.is_like = !this.articleList[i].article
          .is_like;
        if (this.articleList[i].article.is_like == true) {
          this.articleList[i].article.like_times += 1;
        } else {
          this.articleList[i].article.like_times -= 1;
        }
      });
    },
    // 文章详情
    articleDetail(scope) {
      this.$router.push({
        name: "article_detail",
        params: { id: scope.id, isRead: false }
      });
    },
    radioDetail(scope) {
      this.$router.push({
        name: "hot_detail",
        params: { id: scope.article.id, title: scope.article.title }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.getList(this.params);
  }
};
</script>
<style lang="scss" scoped>
.content-l {
  min-height: 800px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.top-nav {
  display: flex;
  background: #ffffff;
  justify-content: space-between;
  line-height: 50px;
  align-items: center;
  padding: 0 30px;
  margin-bottom: 30px;
  ul {
    display: flex;
    li {
      font-size: 16px;
      margin-right: 50px;
      color: #999999;
      cursor: pointer;
    }
    .actives {
      color: #0091ff;
      border-bottom: 4px solid;
    }
  }
}
.article {
  background: #ffffff;
  // padding: 30px 30px 100px 30px;
  padding: 30px;
  margin-bottom: 30px;
  ul {
    li {
      display: flex;
      margin-bottom: 30px;
      .img {
        margin-right: 15px;
        width: 27%;
        height: 140px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .cont {
        width: 72%;
        position: relative;
        p {
          font-size: 20px;
          line-height: 30px;
          cursor: pointer;
        }
        .num {
          font-size: 14px;
          line-height: 30px;
          color: #999999;
        }
        .read {
          width: 100%;
          font-size: 14px;
          color: #999999;
          position: absolute;
          bottom: 0%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            margin-left: 10px;
            cursor: pointer;
            img {
              cursor: pointer;
              vertical-align: middle;
              margin-top: -2px;
            }
          }
        }
      }
    }
  }
}
.hot {
  padding: 30px;
  margin-bottom: 60px;
  background: #ffff;
  .tit {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 20px;
  }
  ul {
    li {
      margin-bottom: 30px;
      display: flex;
      .img {
        margin-right: 30px;
        width: 18%;
        height: 140px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .hot-box {
        position: relative;
        width: 80%;
        p {
          font-size: 20px;
          cursor: pointer;
        }
        .cont {
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          margin-top: 14px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .num {
          display: flex;
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          position: absolute;
          bottom: 6%;
          width: 100%;
          div {
            margin-right: 10%;
            span {
              margin-left: 10px;
            }
          }
          div:last-child {
            span {
              margin-left: 14px;
            }
          }
        }
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
.noData {
  text-align: center;
  line-height: 500px;
}
.loadMore {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/myCollect/index.vue